"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTracking = handleTracking;
const constants_1 = require("../../constants");
const getTrackingSID = ({ pageId, moduleId, linkId, }) => {
    const sidItems = [];
    if (pageId) {
        sidItems.push(pageId);
    }
    if (moduleId) {
        sidItems.push(moduleId);
    }
    if (linkId) {
        sidItems.push(linkId);
    }
    return sidItems.join('.');
};
function handleTracking(trackingData, itemData, watchAction) {
    const attemptsTrackingData = {
        eventFamily: trackingData.eventFamily || 'MYEBAY',
        actionKind: trackingData.actionKind,
        eventAction: trackingData.eventAction,
        eventProperty: Object.assign(Object.assign({}, trackingData.eventProperty), { itm: (itemData === null || itemData === void 0 ? void 0 : itemData.itemId) || '', var: (itemData === null || itemData === void 0 ? void 0 : itemData.variationId) || '', isMsku: (itemData === null || itemData === void 0 ? void 0 : itemData.isMSKU) ? 'true' : 'false', sid: getTrackingSID({
                pageId: trackingData.pageId,
                moduleId: trackingData.moduleId,
                linkId: trackingData.linkId,
            }) }),
    };
    if (watchAction === constants_1.WATCH_ACTION.ADD_ACTION) {
        attemptsTrackingData.eventProperty.watch = '2';
    }
    else if (watchAction === constants_1.WATCH_ACTION.REMOVE_ACTION) {
        attemptsTrackingData.eventProperty.unwatch = '2';
    }
    const customEventData = new CustomEvent('pulsar', {
        detail: [attemptsTrackingData, { actionKind: trackingData.actionKind }],
    });
    document.dispatchEvent(customEventData);
}
